import { createContext } from 'react'

const BulkSelectionContext = createContext()

export default BulkSelectionContext
